export default "__VITE_ASSET__BXycP5V7__"